export function SearchField({
  clearOnEscape = false,
  className = "",
  inputRef = null,
  onInput,
  onFocusMainArea,
  onKeyDown,
  onSubmit,
  onValueChange,
  placeholder = "",
  value = "",
  ...props
}) {
  function handleInput(event) {
    onValueChange?.(event.currentTarget.value);
    onInput?.(event);
  }

  function handleKeyDown(event) {
    if (event.key === "Enter" && typeof onFocusMainArea === "function") {
      event.preventDefault();
      onSubmit?.();
      onFocusMainArea();
      onKeyDown?.(event);
      return;
    }

    if (event.key === "Escape" && typeof onFocusMainArea === "function") {
      event.preventDefault();
      if (clearOnEscape) {
        onValueChange?.("");
      }
      onFocusMainArea();
      onKeyDown?.(event);
      return;
    }

    onKeyDown?.(event);
  }

  return (
    <input
      class={`control-bar-field${className ? ` ${className}` : ""}`}
      ref={inputRef}
      type="text"
      placeholder={placeholder}
      value={value}
      onInput={handleInput}
      onKeyDown={handleKeyDown}
      {...props}
    />
  );
}
